<!-- 对话框容器 -->
<template>
    <el-container>
        <!-- 1.header区域 -->
        <el-header class="operations-herder">
            <slot name="header"></slot>

            <div v-if="isScreen" class="full-screen cursor-pointer" @click="onFullScreen">
                <el-icon v-if="!fullscreen"><FullScreen /></el-icon>
                <el-icon v-else><BottomLeft /></el-icon>
            </div>
            <div class="operations-herder-right">
                <slot name="header-right" />
            </div>
        </el-header>
        <!-- 2.内容填充区域 -->
        <el-main>
            <div class="main-content" :style="{ height: contentHeight + 'px' }">
                <slot name="content"></slot>
            </div>
        </el-main>
        <!-- 3. footer区域-->
        <el-footer>
            <div class="operations-button-box">
                <slot name="footer"></slot>
            </div>
        </el-footer>
    </el-container>
</template>

<script setup>
import { toRefs } from 'vue'
const props = defineProps({
    contentHeight: {
        type: Number,
        default: 260,
    },
    isScreen: {
        type: Boolean,
        default: false,
    },
    fullscreen: {
        type: Boolean,
        default: false,
    },
})
/* contentHeight 参数用来决定content内容区域的高度 type为数字类型 */
/* isScreen 参数用来决定是否展示全屏按钮 type为Boolean */
const { contentHeight, isScreen, fullscreen } = toRefs(props)
const emit = defineEmits(['onFullScreen'])
// 全屏小屏切换
const onFullScreen = () => {
    emit('onFullScreen', fullscreen.value)
}
</script>

<style lang="scss" scoped>
.main-content {
    overflow: auto;
}
.operations-button {
    display: flex;
    justify-content: center;
}
.operations-herder {
    justify-content: center;
    font-weight: bold;
}
.operations-herder-right {
    position: absolute;
    right: 2vw;
    top: 3.5vh;
}
:deep(.el-footer) {
    height: 80px;
}
.operations-button-box {
    display: flex;
    justify-content: center;
}
.full-screen {
    position: absolute;
    right: 1%;
}
</style>
